import { mainApi } from '../../../api/mainApi';
import { AccessState } from '../../../types';
import { middlewareApi } from '../../middleware/middlewareApi';
import { ChunkStatesData } from '../interfaces/chunkStates.interface';

export const chunkStatesTags = middlewareApi.enhanceEndpoints({
  addTagTypes: ['eventsNews'],
});
// Define a service using a base URL and expected endpoints
export const chunkStatesApi = chunkStatesTags.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * @GET  event chunk update from code and category
     */
    getEventChunk: builder.query<ChunkStatesData, { code: string; category: 'events' }>({
      queryFn: async ({ code, category }, { dispatch, getState }) => {
        try {
          const {
            access: { currentProfile },
          } = getState() as { access: AccessState };
          const user_profile_id = currentProfile?.profileId;

          const { data } = await mainApi.get<ChunkStatesData>(`/${category}/${code}/progress`, {
            params: {
              user_profile_id,
            },
          });

          return { data };
        } catch (error: any) {
          return { error };
        }
      },
      // providesTags: (result, error) => [{ type: 'eventsNews',  }],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetEventChunkQuery, useLazyGetEventChunkQuery } = chunkStatesApi;
